import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'osp-dropdown-item',
  standalone: true,
  templateUrl: './dropdown-item.component.html',
  styleUrl: './dropdown-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownItemComponent {
  @Input() label = '';
  @Input() selected = false;
  @Input() disabled = false;
  @Input() icon = '';
}
